<div
  class="card-container tw-relative tw-size-full tw-@container"
  (mouseleave)="onMouseLeave()"
  (pointerenter)="onMouseEnter()"
>
  <div
    class="card-inner tw-relative tw-size-full"
    [class.flipped]="isFlipped()"
  >
    <!-- front side -->
    <div class="card-face card-front tw-absolute tw-inset-0 tw-overflow-hidden tw-rounded-lg">
      <div class="card-tilt tw-relative tw-size-full">
        @if (!isAgent()) {
          <div class="tw-absolute tw-inset-0 tw-bg-[#1b1e33]"></div>
        }
        <div class="tw-relative tw-z-1 tw-flex tw-size-full tw-flex-col tw-items-center tw-justify-center tw-p-[8%]">
          <img
            [src]="caseImage()"
            alt="agent-card"
            class="tw-size-full tw-object-cover"
          />
        </div>
        <div
          class="card-bg tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10"
          [style.background-image]="frameBackgroundImage"
        ></div>
      </div>
    </div>
    <!---->

    <!-- back side -->
    <div class="card-face card-back tw-absolute tw-inset-0 tw-overflow-hidden tw-rounded-lg">
      <div class="card-tilt tw-relative tw-size-full">
        @if (!isAgent()) {
          <div class="tw-absolute tw-inset-0 tw-bg-[#1b1e33]"></div>
        }
        <div class="tw-relative tw-z-1 tw-flex tw-size-full tw-flex-col tw-items-center tw-justify-center tw-p-[8%]">
          <div class="tw-flex tw-grow tw-items-center tw-justify-center tw-px-2 @[85px]:tw-pt-4">
            <img
              [src]="image()"
              alt="weapon-card"
              class="tw-w-full tw-object-contain"
            />
          </div>

          <div class="card-back-caption tw-mb-4 tw-hidden tw-w-full tw-flex-col tw-items-center tw-gap-1 @[100px]:tw-flex">
            <span
              class="exterior-text tw-w-full tw-truncate tw-px-2 tw-text-center tw-font-medium tw-uppercase tw-tracking-wide tw-text-white/50"
            >
              {{ exterior() }}
            </span>
            <div
              class="name-text tw-line-clamp-2 tw-w-full tw-bg-gradient-to-r tw-from-[#C69CFF] tw-to-[#FFF3AD] tw-bg-clip-text tw-px-2 tw-text-center tw-font-bold tw-uppercase tw-leading-tight tw-text-transparent"
            >
              {{ skin() }}
            </div>
          </div>
        </div>
        <div
          class="card-bg tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10"
          [style.background-image]="frameBackgroundImage"
        ></div>
      </div>
    </div>
    <!---->
  </div>
</div>
